;(function () {
	'use strict';

	if (!customElements.get('trending-products')) {
		class TrendingProducts extends HTMLElement {
			constructor() {
				super();
				this.slider = this.querySelector('.swiper.ab-trending-products__slider');
				this.slides = Array.from(this.querySelectorAll('.swiper-slide'));
				this.nextBtns = Array.from(this.querySelectorAll('.ab-next'));
				this.prevBtns = Array.from(this.querySelectorAll('.ab-prev'));
				this.swiper = null;
			}

			connectedCallback() {
				this.initSwiper();
				window.addEventListener('resize', () => this.initSwiper.call(this));
			}
		}

		TrendingProducts.prototype.initSwiper = function() {
			if (this.slider) {
				let { slidesPerView, gap, slidesPerViewMobile, slidesPerViewTablet } = this.dataset;
				slidesPerView = this.slides.length <= slidesPerView && this.slides.length != 1 ?  this.slides.length - 1 : slidesPerView;
				const spaceBetween = gap == 'true' ? 0 : 30;
				const mobileSlidesPerView = slidesPerViewMobile || 1;
				const tabletSlidesPerView = slidesPerViewTablet || 2.3;
				const smallTabletSlidesPerView = slidesPerViewTablet || 1.4;
				this.swiper = new Swiper(this.slider, {
					loop: false,
					lazy: true,
					autoplay: false,
					speed: 400,
					spaceBetween: 30,
					slidesPerView: mobileSlidesPerView,
					mousewheel: {
						forceToAxis: true
					},
					breakpoints: {
						750: {
							slidesPerView: smallTabletSlidesPerView,
							spaceBetween
						},
						950: {
							slidesPerView: tabletSlidesPerView,
							spaceBetween
						},
						1100: {
							slidesPerView,
							spaceBetween
						}
					},
					navigation: {
						nextEl: this.nextBtns[0],
						prevEl: this.prevBtns[0],
						disabledClass: 'ab-nav--disabled'
					}
				});

				this.nextBtns.forEach((btn, ind) => {
					if (ind == 0) {
						return
					}
						btn.addEventListener('click', () => this.swiper.slideNext());
				});

				this.prevBtns.forEach((btn, ind) => {
					if (ind == 0) {
						return
					}
						btn.addEventListener('click', () => this.swiper.slidePrev());
				});
			}
		};

		customElements.define('trending-products', TrendingProducts);
	}
})()
